import {
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsUUID,
  IsOptional,
  IsString,
  IsIn,
} from 'class-validator';
import { Type } from 'class-transformer';

import { FileInputValue } from '@vk-hr-tek/ui/input';

export class UpdatePolicyDto {
  @IsUUID()
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsUUID(undefined, { groups: ['form'] })
  @IsString({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  categoryId: string;

  @IsIn(['true', 'false'], { groups: ['form'] })
  @IsString({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  hideIfAccepted?: 'true' | 'false';

  @IsUUID(undefined, { groups: ['form'] })
  @IsString({ groups: ['form'] })
  @IsNotEmpty({ groups: ['form'] })
  companyId: string;

  @IsString({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  unitType?: string;

  @IsArray({ groups: ['form'] })
  @Type(() => String)
  @IsOptional({ groups: ['form'] })
  unitIds?: string[];

  @IsArray({ groups: ['form'] })
  @Type(() => String)
  @IsOptional({ groups: ['form'] })
  positions?: string[];

  @IsArray({ groups: ['form'] })
  @Type(() => String)
  @IsOptional({ groups: ['form'] })
  employees?: string[];

  @IsArray({ groups: ['form'] })
  @Type(() => String)
  @IsOptional({ groups: ['form'] })
  files?: FileInputValue[];

  @IsString({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  employeesAddingMode?: 'manual' | 'upload';

  @IsBoolean({ groups: ['form'] })
  @IsOptional({ groups: ['form'] })
  includeUnitManagers?: boolean;
}
